// src/hooks/analysis/summary/forbiddenWords.ts

import { useMemo } from 'react';
import { AnalysisValueView } from 'src/api/generated';
import { getForbiddenWords } from 'src/utils/analysisValues/forbiddenWords/forbiddenWords';

export const useForbiddenWords = (analysisValues: AnalysisValueView[]) => {
  return useMemo(() => getForbiddenWords(analysisValues), [analysisValues]);
};
